'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { ClpPrimaryCtaButton } from '@/features/course-landing-page/components/clp-primary-cta-button/clp-primary-cta-button.react-component';
import styles from './enrolled-sticky-footer-content.module.scss';

/**
 * EnrolledStickyFooterContent component displays only a CTA button for enrolled users.
 * This provides a simple action for users who are already enrolled in the course.
 */
export const EnrolledStickyFooterContent: React.FC = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ClpPrimaryCtaButton className={styles["transactional-cta-button"]} udStyle="primary" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};